import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuthService } from '../../../@core/auth/auth.service';
import { Fieldman } from '../models/fieldman';

@Injectable({
  providedIn: 'root'
})
export class FieldmanService {

  protected basePath = '/';

  public wordList: Fieldman[] = [];
  public isLoading: boolean = true;
  private AuthToken: string;

  constructor(
    public authService: AuthService,
    protected httpClient: HttpClient
  ) {
    this.basePath = environment.PLATFORM_API_URL;
  }

  public putFieldman(fieldmen: Fieldman): Observable<Fieldman> {
    return this.httpClient.put<Fieldman>(`${this.basePath}/api/Fieldman/${fieldmen.id}`, fieldmen);
  }

  public getFieldman(id?: number): Observable<Fieldman> {

    if (id != null) { return this.httpClient.get<Fieldman>(`${this.basePath}/api/Fieldman/${id}`); }
    else { return this.httpClient.get<Fieldman>(`${this.basePath}/api/Fieldman`); }
  }

  public getFieldmen(): Observable<Fieldman[]> {
    return this.httpClient.get<Fieldman[]>(`${this.basePath}/api/Fieldman`);
  }

  public deleteFieldman(id: number) {

    return this.httpClient.delete(`${this.basePath}/api/Fieldman/${id}`);
  }

  public postFieldman(Fieldman: Fieldman): Observable<Fieldman> {
    return this.httpClient.post<Fieldman>(`${this.basePath}/api/Fieldman`, Fieldman);
  }
}
